(() => {
  const configNode = document.getElementById('bazar-pillow-config');
  if (!configNode || customElements.get('bazar-pillow-upsell')) return;
  const cfg = JSON.parse(configNode.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const pt = document.documentElement.lang.startsWith('pt');
  const en = document.documentElement.lang.startsWith('en');
  const ar = document.documentElement.lang.startsWith('ar');
  const copy = ar ? ['أكمل أغطية الوسائد','حشوة وسادة · 50 × 70 سم','أضف','حشوة','حشوات','تمت الإضافة إلى السلة','تعذر الإضافة. حاول مرة أخرى.'] : en ? ['Complete your pillowcases','Pillow insert · 50 × 70 cm','Add','insert','inserts','Added to your cart','Unable to add. Please try again.'] : pt ? ['Complete as suas fronhas','Enchimento de almofada · 50 × 70 cm','Adicionar','enchimento','enchimentos','Adicionado ao carrinho','Não foi possível adicionar. Tente novamente.'] : ['Completa tus fundas','Relleno de almohada · 50 × 70 cm','Añadir','relleno','rellenos','Añadido al carrito','No se ha podido añadir. Vuelve a intentarlo.'];
  let cart = null, pending = null, busy = false;
  const money = n => new Intl.NumberFormat(document.documentElement.lang || 'es',{style:'currency',currency:cfg.currency || 'EUR'}).format(n/100);
  async function readCart() {
    if (!pending) pending = fetch(root+'cart.js').then(r => {if(!r.ok) throw Error();return r.json();}).then(c => cart=c).finally(()=>pending=null);
    return pending;
  }
  function quantities(items, selected, quantity) {
    let needed=0, have=0, selectedInCart=0;
    for(const item of items) {
      if(String(item.variant_id)===String(cfg.id)) have+=item.quantity;
      needed+=(cfg.variants[item.variant_id]||0)*item.quantity;
      if(String(item.variant_id)===String(selected)) selectedInCart+=item.quantity;
    }
    if(selected) needed+=(cfg.variants[selected]||0)*Math.max(0,quantity-selectedInCart);
    return Math.max(0,Math.min(needed-have,cfg.stock-have));
  }
  class PillowUpsell extends HTMLElement {
    connectedCallback() {
      this.refresh = () => this.render();
      this.onChange = () => {clearTimeout(this.timer);this.timer=setTimeout(()=>this.render(),150);};
      document.addEventListener('change',this.onChange);
      if(typeof subscribe==='function') {
        this.unsubCart=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>readCart().then(()=>this.render()).catch(()=>{}));
        this.unsubVariant=subscribe(PUB_SUB_EVENTS.variantChange,()=>this.render());
      }
      this.addEventListener('click',this.handleClick);
      readCart().then(()=>this.render()).catch(()=>{});
    }
    disconnectedCallback() {
      document.removeEventListener('change',this.onChange);this.removeEventListener('click',this.handleClick);
      this.unsubCart?.();this.unsubVariant?.();clearTimeout(this.timer);
    }
    missing() {
      const form=this.dataset.context==='product' ? document.getElementById(this.dataset.form) : null;
      const selected=form?.querySelector('[name="id"]')?.value;
      if(this.dataset.context==='product' && (!selected || !cfg.variants[selected] || form.querySelector('[name="id"]').disabled)) return 0;
      const quantity=Math.max(1,Number(form ? new FormData(form).get('quantity') : 1)||1);
      const remaining=quantities(cart?.items||[],selected,quantity);
      return selected ? Math.min(remaining,cfg.variants[selected]*quantity) : remaining;
    }
    render() {
      const count=this.missing();this.hidden=!cfg.available || !cfg.id || !cart || count<1;
      if(this.hidden)return;
      this.replaceChildren();
      const card=document.createElement('div');card.className='bazar-pillow-card';
      const link=document.createElement('a');link.href=cfg.url;
      const img=document.createElement('img');img.src=cfg.image;img.width=72;img.height=72;img.alt=copy[1];img.loading='lazy';link.append(img);card.append(link);
      const content=document.createElement('div');content.className='bazar-pillow-content';
      const title=document.createElement('strong');title.textContent=copy[0];content.append(title);
      const desc=document.createElement('p');desc.textContent=copy[1];content.append(desc);
      const actions=document.createElement('div');actions.className='bazar-pillow-actions';
      for(let q=1;q<=Math.min(count,2);q++) {
        const button=document.createElement('button');button.type='button';button.dataset.quantity=q;
        button.textContent=`${copy[2]} ${q} ${copy[q===1?3:4]} · ${money(cfg.price*q)}`;button.disabled=busy;actions.append(button);
      }
      content.append(actions);const status=document.createElement('span');status.className='bazar-pillow-status';status.setAttribute('role','status');content.append(status);card.append(content);this.append(card);
    }
    async handleClick(event) {
      const button=event.target.closest('button[data-quantity]');if(!button || busy)return;
      busy=true;document.querySelectorAll('bazar-pillow-upsell button').forEach(b=>b.disabled=true);
      const status=this.querySelector('[role="status"]');
      try {
        await readCart();const quantity=Math.min(Number(button.dataset.quantity),this.missing());
        if(quantity<1){document.querySelectorAll('bazar-pillow-upsell').forEach(e=>e.render());return;}
        const drawer=document.querySelector('cart-drawer');
        const sections=drawer?.getSectionsToRender().map(s=>s.id)||['cart-icon-bubble'];
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:cfg.id,quantity}],sections,sections_url:location.pathname})});
        const result=await response.json();if(!response.ok || result.status)throw Error(result.description||copy[6]);
        await readCart();
        if(this.dataset.context==='cart' && location.pathname.replace(/\/$/,'')===root.replace(/\/$/,'')+'/cart'){location.reload();return;}
        if(drawer){drawer.classList.remove('is-empty');drawer.renderContents(result);}
        if(typeof publish==='function')publish(PUB_SUB_EVENTS.cartUpdate,{source:'bazar-pillow-upsell',cartData:cart});
        document.querySelectorAll('bazar-pillow-upsell').forEach(e=>e.render());
        const live=this.querySelector('[role="status"]');if(live)live.textContent=copy[5];
      } catch(error) {if(status)status.textContent=error.message || copy[6];}
      finally {busy=false;document.querySelectorAll('bazar-pillow-upsell button').forEach(b=>b.disabled=false);}
    }
  }
  customElements.define('bazar-pillow-upsell',PillowUpsell);
})();
